import * as ambassadorWixEcomV1TotalsCalculation from './ecom-v1-totals-calculation-totals-calculator.http.js';
import * as ambassadorWixEcomV1TotalsCalculationTypes from './ecom-v1-totals-calculation-totals-calculator.types.js';
import * as ambassadorWixEcomV1TotalsCalculationUniversalTypes from './ecom-v1-totals-calculation-totals-calculator.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function calculateTotals(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1TotalsCalculationUniversalTypes.CalculateTotalsRequest,
  ambassadorWixEcomV1TotalsCalculationTypes.CalculateTotalsRequest,
  ambassadorWixEcomV1TotalsCalculationUniversalTypes.CalculateTotalsResponse,
  ambassadorWixEcomV1TotalsCalculationTypes.CalculateTotalsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1TotalsCalculation.calculateTotals(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/calculate-totals',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TotalsCalculationEntity as TotalsCalculationEntityOriginal,
  CalculateTotalsRequest as CalculateTotalsRequestOriginal,
  CalculateTotalsRequestCouponOneOf as CalculateTotalsRequestCouponOneOfOriginal,
  CalculateTotalsRequestGiftCardOneOf as CalculateTotalsRequestGiftCardOneOfOriginal,
  LineItem as LineItemOriginal,
  CatalogReference as CatalogReferenceOriginal,
  PhysicalProperties as PhysicalPropertiesOriginal,
  Dimensions as DimensionsOriginal,
  DimensionsUnit as DimensionsUnitOriginal,
  DimensionsUnitWithLiterals as DimensionsUnitWithLiteralsOriginal,
  Scope as ScopeOriginal,
  Group as GroupOriginal,
  SubscriptionSettings as SubscriptionSettingsOriginal,
  SubscriptionFrequency as SubscriptionFrequencyOriginal,
  SubscriptionFrequencyWithLiterals as SubscriptionFrequencyWithLiteralsOriginal,
  PaymentOptionType as PaymentOptionTypeOriginal,
  PaymentOptionTypeWithLiterals as PaymentOptionTypeWithLiteralsOriginal,
  ServiceProperties as ServicePropertiesOriginal,
  ItemType as ItemTypeOriginal,
  ItemTypeItemTypeDataOneOf as ItemTypeItemTypeDataOneOfOriginal,
  ItemTypePreset as ItemTypePresetOriginal,
  ItemTypePresetWithLiterals as ItemTypePresetWithLiteralsOriginal,
  TaxableAddress as TaxableAddressOriginal,
  TaxableAddressTaxableAddressDataOneOf as TaxableAddressTaxableAddressDataOneOfOriginal,
  TaxableAddressType as TaxableAddressTypeOriginal,
  TaxableAddressTypeWithLiterals as TaxableAddressTypeWithLiteralsOriginal,
  ApiV1AdditionalFee as ApiV1AdditionalFeeOriginal,
  V1TaxDetails as V1TaxDetailsOriginal,
  ModifierGroup as ModifierGroupOriginal,
  TranslatableString as TranslatableStringOriginal,
  ItemModifier as ItemModifierOriginal,
  PlatformFee as PlatformFeeOriginal,
  PlatformFeeChargeType as PlatformFeeChargeTypeOriginal,
  PlatformFeeChargeTypeWithLiterals as PlatformFeeChargeTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  SelectedShippingOption as SelectedShippingOptionOriginal,
  SelectedMemberships as SelectedMembershipsOriginal,
  SelectedMembership as SelectedMembershipOriginal,
  CarrierShippingOption as CarrierShippingOptionOriginal,
  ShippingOption as ShippingOptionOriginal,
  DeliveryLogistics as DeliveryLogisticsOriginal,
  PickupDetails as PickupDetailsOriginal,
  PickupMethod as PickupMethodOriginal,
  PickupMethodWithLiterals as PickupMethodWithLiteralsOriginal,
  DeliveryTimeSlot as DeliveryTimeSlotOriginal,
  ShippingPrice as ShippingPriceOriginal,
  MultiCurrencyPrice as MultiCurrencyPriceOriginal,
  OtherCharge as OtherChargeOriginal,
  ChargeType as ChargeTypeOriginal,
  ChargeTypeWithLiterals as ChargeTypeWithLiteralsOriginal,
  DeliveryAllocation as DeliveryAllocationOriginal,
  Carrier as CarrierOriginal,
  Region as RegionOriginal,
  ApplicableLineItems as ApplicableLineItemsOriginal,
  AppliedDiscount as AppliedDiscountOriginal,
  AppliedDiscountDiscountSourceOneOf as AppliedDiscountDiscountSourceOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  Coupon as CouponOriginal,
  MerchantDiscount as MerchantDiscountOriginal,
  DiscountRule as DiscountRuleOriginal,
  DiscountRuleName as DiscountRuleNameOriginal,
  LineItemDiscount as LineItemDiscountOriginal,
  ItemCombination as ItemCombinationOriginal,
  ItemCombinationLineItem as ItemCombinationLineItemOriginal,
  AdditionalFee as AdditionalFeeOriginal,
  TaxDetails as TaxDetailsOriginal,
  DataFetchType as DataFetchTypeOriginal,
  DataFetchTypeWithLiterals as DataFetchTypeWithLiteralsOriginal,
  ExternalReference as ExternalReferenceOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  GiftCardInput as GiftCardInputOriginal,
  MembershipSelection as MembershipSelectionOriginal,
  ExistingMembershipSelection as ExistingMembershipSelectionOriginal,
  FutureMembershipSelection as FutureMembershipSelectionOriginal,
  CalculateTotalsResponse as CalculateTotalsResponseOriginal,
  CalculatedLineItem as CalculatedLineItemOriginal,
  LineItemPricesData as LineItemPricesDataOriginal,
  ItemTaxFullDetails as ItemTaxFullDetailsOriginal,
  TaxRateBreakdown as TaxRateBreakdownOriginal,
  TaxBreakdown as TaxBreakdownOriginal,
  JurisdictionType as JurisdictionTypeOriginal,
  JurisdictionTypeWithLiterals as JurisdictionTypeWithLiteralsOriginal,
  CalculatedItemModifier as CalculatedItemModifierOriginal,
  PriceSummary as PriceSummaryOriginal,
  GiftCard as GiftCardOriginal,
  TaxSummary as TaxSummaryOriginal,
  TaxCalculationDetails as TaxCalculationDetailsOriginal,
  TaxCalculationDetailsCalculationDetailsOneOf as TaxCalculationDetailsCalculationDetailsOneOfOriginal,
  RateType as RateTypeOriginal,
  RateTypeWithLiterals as RateTypeWithLiteralsOriginal,
  ManualCalculationReason as ManualCalculationReasonOriginal,
  ManualCalculationReasonWithLiterals as ManualCalculationReasonWithLiteralsOriginal,
  AutoTaxFallbackCalculationDetails as AutoTaxFallbackCalculationDetailsOriginal,
  FallbackReason as FallbackReasonOriginal,
  FallbackReasonWithLiterals as FallbackReasonWithLiteralsOriginal,
  ApplicationError as ApplicationErrorOriginal,
  AggregatedTaxBreakdown as AggregatedTaxBreakdownOriginal,
  ShippingInformation as ShippingInformationOriginal,
  ShippingRegion as ShippingRegionOriginal,
  SelectedCarrierServiceOption as SelectedCarrierServiceOptionOriginal,
  SelectedCarrierServiceOptionPrices as SelectedCarrierServiceOptionPricesOriginal,
  SelectedCarrierServiceOptionOtherCharge as SelectedCarrierServiceOptionOtherChargeOriginal,
  CarrierServiceOption as CarrierServiceOptionOriginal,
  CalculationErrors as CalculationErrorsOriginal,
  CalculationErrorsShippingCalculationErrorOneOf as CalculationErrorsShippingCalculationErrorOneOfOriginal,
  Details as DetailsOriginal,
  DetailsKindOneOf as DetailsKindOneOfOriginal,
  ValidationError as ValidationErrorOriginal,
  RuleType as RuleTypeOriginal,
  RuleTypeWithLiterals as RuleTypeWithLiteralsOriginal,
  FieldViolation as FieldViolationOriginal,
  SystemError as SystemErrorOriginal,
  CarrierErrors as CarrierErrorsOriginal,
  CarrierError as CarrierErrorOriginal,
  GiftCardCalculationError as GiftCardCalculationErrorOriginal,
  WeightUnit as WeightUnitOriginal,
  WeightUnitWithLiterals as WeightUnitWithLiteralsOriginal,
  MembershipOptions as MembershipOptionsOriginal,
  Membership as MembershipOriginal,
  MembershipName as MembershipNameOriginal,
  MembershipPaymentCredits as MembershipPaymentCreditsOriginal,
  BalanceType as BalanceTypeOriginal,
  BalanceTypeWithLiterals as BalanceTypeWithLiteralsOriginal,
  InvalidMembership as InvalidMembershipOriginal,
  ValidatedExistingMemberships as ValidatedExistingMembershipsOriginal,
  ExistingMembership as ExistingMembershipOriginal,
  V1Membership as V1MembershipOriginal,
  CoveredLineItem as CoveredLineItemOriginal,
  ValidatedPurchasablePlans as ValidatedPurchasablePlansOriginal,
  PurchasablePlan as PurchasablePlanOriginal,
  Benefit as BenefitOriginal,
  BenefitQuotaOneOf as BenefitQuotaOneOfOriginal,
  QuotaType as QuotaTypeOriginal,
  QuotaTypeWithLiterals as QuotaTypeWithLiteralsOriginal,
  LimitedQuota as LimitedQuotaOriginal,
  LimitedQuotaType as LimitedQuotaTypeOriginal,
  LimitedQuotaTypeWithLiterals as LimitedQuotaTypeWithLiteralsOriginal,
  LineItemCoverage as LineItemCoverageOriginal,
  V1AdditionalFee as V1AdditionalFeeOriginal,
  AdditionalFeeSource as AdditionalFeeSourceOriginal,
  AdditionalFeeSourceWithLiterals as AdditionalFeeSourceWithLiteralsOriginal,
  PlatformFeeSummary as PlatformFeeSummaryOriginal,
  CalculatedPlatformFee as CalculatedPlatformFeeOriginal,
} from './ecom-v1-totals-calculation-totals-calculator.types.js';
